<template>
    <LegalTaxSituationFields v-model="formValues"></LegalTaxSituationFields>
    <div class="border-t border-t-gray-300">
        <LegalTaxResidenciesFields v-model="formValues"></LegalTaxResidenciesFields>
    </div>
</template>

<script setup lang="ts">
import { getLegalWidgetFormValidationRules, initializeLegalWidgetForm, TaxSituationAndResidencies } from './forms'
import { useVModel } from '@vueuse/core'
import LegalTaxSituationFields from './fields/LegalTaxSituationFields.vue'
import LegalTaxResidenciesFields from './fields/LegalTaxResidenciesFields.vue'

const props = defineProps<{
    modelValue: TaxSituationAndResidencies
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
initializeLegalWidgetForm({ ...getLegalWidgetFormValidationRules('tax_situation') })
</script>
